import { OptionallyVisible } from 'components';
import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import Link from 'components/link';

import { CryptoPayout } from 'types/cryptoPayout';

import { capitalizeFirstLetter } from 'utils/string';

import LABELS from './keys';
import { AssetImage, GapItem, Item, ItemName, ItemValue, SecondaryItemValue, SectionWrapper } from './styles';

interface CryptoDetailsSectionProps {
  payout: CryptoPayout;
}

export const CryptoDetailsSection = ({ payout }: CryptoDetailsSectionProps) => {
  const { t } = useTranslation();

  return (
    <Panel label={t(LABELS.TITLE)}>
      <SectionWrapper>
        <Item>
          <ItemName>{t(LABELS.CRYPTOCURRENCY)}</ItemName>
          <GapItem>
            <OptionallyVisible visible={Boolean(payout.cryptoAsset?.iconUrl)}>
              <AssetImage src={payout.cryptoAsset?.iconUrl} />
            </OptionallyVisible>
            {payout.cryptoCurrencyCode}
          </GapItem>
        </Item>

        <Item>
          <ItemName>{t(LABELS.NETWORK)}</ItemName>
          <ItemValue>{capitalizeFirstLetter(payout.network ?? '-')}</ItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.WALLET_ADDRESS)}</ItemName>
          <SecondaryItemValue>{payout.walletAddress}</SecondaryItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.WALLET_MEMO)}</ItemName>
          <ItemValue>{payout.walletMemo ?? '-'}</ItemValue>
        </Item>

        <Item>
          <ItemName>{t(LABELS.TRANSACTION_HASH)}</ItemName>
          <SecondaryItemValue>
            {payout.onChainExplorerURL ? (
              <Link target="_blank" to={payout.onChainExplorerURL} decorated>
                {payout.onChainTransactionHash}
              </Link>
            ) : (
              payout.onChainTransactionHash
            )}
          </SecondaryItemValue>
        </Item>
      </SectionWrapper>
    </Panel>
  );
};
